export default __webpack_public_path__ + "static/media/daxa-icon.d98de915.svg";